<ng-container *ngIf="isVisible">
    <div [ngClass]="field.panelClass" [id]="field.id + '-container'">
        <ng-container *ngIf="options$ | async as resolvedOptions">
            <mat-form-field class="full-width" [ngClass]="{ required: isRequired }">
                <mat-label *ngIf="field.label">
                    {{ field.label | translate
                    }}<span
                        *ngIf="isRequiredStatusField && select.disabled"
                        class="status-required-marker"
                        aria-hidden="true"
                        >&#32;*</span
                    >
                </mat-label>
                <mat-select
                    #select
                    disableOptionCentering
                    [id]="field.id"
                    [attr.formcontrolname]="field.name"
                    [placeholder]="fieldUtils.getPlaceholder(field)"
                    [formControl]="control"
                    [disabled]="field.readonly || control.disabled"
                    [required]="isRequired"
                    (selectionChange)="onChange($event, resolvedOptions)"
                >
                    <mat-option *ngFor="let option of resolvedOptions" [value]="getValue(option)">
                        {{ getDisplayText(option) | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <div class="mat-error" *ngIf="hasError">
            <div *ngFor="let error of errorMessages">{{ error | translateSmart }}</div>
        </div>
    </div>
</ng-container>
